<template>
  <v-container id="contactos-alta" fluid>
    <v-dialog v-model="show" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container v-if="show">
            <validation-observer id="obContacto" v-slot="{ handleSubmit }" ref="formContacto">
              <form id="altaContacto" @submit.prevent="handleSubmit(validateForm)">
                <v-row align="center" justify="center">
                  <v-col cols="12">
                    <validation-provider v-slot="{ errors }" name="nombre contacto" rules="required|max:45">
                      <v-text-field v-model="dataForm.nombre" color="#ac8a2e" :error-messages="errors" name="input-6-1" label="Nombre contacto" />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12">
                    <validation-provider v-slot="{ errors }" name="razón social" rules="max:45">
                      <v-text-field v-model="dataForm.razon_social" color="#ac8a2e" :error-messages="errors" name="input-6-1" label="Razón social" />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12">
                    <validation-provider v-slot="{ errors }" name="cuit" rules="max:45">
                      <v-text-field v-model="dataForm.cuit" color="#ac8a2e" :error-messages="errors" name="input-6-1" label="Cuit" />
                    </validation-provider>
                  </v-col>
                </v-row>
              </form>
            </validation-observer>
            <v-card-actions>
              <v-spacer />
              <v-btn color="blue darken-1" text @click="close">
                Cancelar
              </v-btn>
              <v-btn color="blue darken-1" text form="altaContacto" type="submit">
                Guardar
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    props: {
      mode: {
        type: String,
        required: false,
        default: 'new',
      },
      aEditar: {
        type: Object,
        required: false,
        default: null,
      },
      show: {
        type: Boolean,
        required: true,
        default: false,
      },
    },
    data () {
      return {
        dataForm: {},
      }
    },
    computed: {
      formTitle () {
        return this.mode === 'new' ? 'Nuevo contacto' : 'Editar contacto'
      },
    },
    watch: {
      aEditar (val) {
        this.dataForm = val
      },
    },
    methods: {
      validateForm (scope) {
        this.enviarContacto()
      },
      close () {
        this.dataForm = {}
        this.$emit('close')
      },
      enviarContacto: async function () {
        let method = ''
        let id = ''
        let message = ''
        if (this.mode === 'new') {
          method = 'post'
          message = ['Alta de contacto exitosa']
        } else {
          method = 'put'
          message = ['Edición de contacto exitosa']
          id = '/' + this.dataForm.id
        }
        await this.$http({
          method: method,
          url: '/api/contactos' + id,
          data: {
            ...this.dataForm,
          },
        }).then(response => {
          this.close()
          this.$emit('update', response.data)
          this.$store.commit('toast/show', { tipo: 'success', messages: message })
        }).catch(error => {
          this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
        })
      },
    },
  }
</script>
